import { titleSectionTpl, titleSectionModATpl } from './section';
import { titleWindowTpl } from './window';

export { 
    titleSectionTpl,
    titleSectionModATpl,
    titleWindowTpl
}